"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadAliasNamingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
const orcadHighestLevelWins_1 = require("./orcadHighestLevelWins");
class OrCadAliasNamingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Naming;
    }
    apply(group, _hierarchy) {
        if (!group.hasLabelType('alias')) {
            return undefined;
        }
        let shallowestAliasDepth;
        for (const [instance, nets] of group.getNets()) {
            const depth = instance.path.length;
            if (shallowestAliasDepth !== undefined && depth >= shallowestAliasDepth) {
                continue;
            }
            if (nets.some((net) => net.labels.some((l) => l.labelType === 'alias'))) {
                shallowestAliasDepth = depth;
            }
        }
        if ((0, orcadHighestLevelWins_1.deferToShallowerSystemId)(group, shallowestAliasDepth)) {
            return undefined;
        }
        return group
            .getNetLabels()
            .filter((l) => l.labelType === 'alias')
            .map((l) => l.formattedLabel ?? l.originalLabel)
            .sort()[0];
    }
}
exports.OrCadAliasNamingRule = OrCadAliasNamingRule;
//# sourceMappingURL=OrcadAliasNamingRule.js.map